"use client";

import React from "react";

import { Card } from "./ui/card";
import purchase from "../assets/images/purchase.png";
import { Button } from "./ui/button";
import { Lock } from "lucide-react";

const ForexComplete = ({
  assetName,
  sellAssetName,
  onDone,
  tradeType,
  isOrder,
  targetPrice,
  isPostTrade,
  cryptoAmount,
}) => {
  const finalAssetName = assetName?.toUpperCase() || "Asset";

  return (
    <>
      {!isOrder && tradeType === "Buy" && (
        <Card className="w-full bg-white rounded-2xl shadow-xl p-12 flex flex-col items-center text-center">
          <img
            src={purchase}
            alt="Purchase Success"
            width={194}
            height={136}
            className="mb-6"
          />

          <h2 className="text-2xl font-bold text-purple-700 mb-4">
            Your buy order has been set
          </h2>
          <p className="text-lg font-normal text-gray-600 mb-6">
            {cryptoAmount
              ? `You've successfully purchased ${cryptoAmount} ${finalAssetName}`
              : "Your buy order has been successfully placed."}
          </p>

          <Button
            onClick={onDone}
            className="w-full max-w-md py-3 bg-gradient-to-r from-purple-500 to-rose-500 text-white rounded-full font-bold h-16 mb-6"
          >
            Done
          </Button>

          <div className="flex items-center justify-center gap-1 text-sm text-gray-500">
            <Lock size={12} />
            <p>Secured by R0eight</p>
          </div>
        </Card>
      )}
      {!isOrder && tradeType === "Sell" && (
        <Card className="w-full bg-white rounded-2xl shadow-xl p-12 flex flex-col items-center text-center">
          <img
            src={purchase}
            alt="Sell Success"
            width={194}
            height={136}
            className="mb-6"
          />

          <h2 className="text-2xl font-bold text-purple-700 mb-4">
            Cash in Hand.
          </h2>
          <p className="text-lg font-normal text-gray-600 mb-6">
            You've freed up funds and kept control of your next move.
          </p>

          <Button
            onClick={onDone}
            className="w-full max-w-md py-3 bg-gradient-to-r from-purple-500 to-rose-500 text-white rounded-full font-bold h-16 mb-6"
          >
            Done
          </Button>

          <div className="flex items-center justify-center gap-1 text-sm text-gray-500">
            <Lock size={12} />
            <p>Secured by R0eight</p>
          </div>
        </Card>
      )}
      {isOrder && tradeType === "Buy" && (
        <Card className="w-full bg-white rounded-2xl shadow-xl p-12 flex flex-col items-center text-center">
          <img
            src={purchase}
            alt="Purchase Success"
            width={194}
            height={136}
            className="mb-6"
          />

          <h2 className="text-2xl font-bold text-purple-700 mb-4">
            Your buy order has been set
          </h2>
          <p className="text-lg font-normal text-gray-600 mb-6">
            {cryptoAmount && targetPrice
              ? `You'll buy ${cryptoAmount} ${finalAssetName} if its price goes down to R ${targetPrice}`
              : "Your buy order has been successfully placed."}
          </p>

          <Button
            onClick={onDone}
            className="w-full max-w-md py-3 bg-gradient-to-r from-purple-500 to-rose-500 text-white rounded-full font-bold h-16 mb-6"
          >
            Done
          </Button>

          <div className="flex items-center justify-center gap-1 text-sm text-gray-500">
            <Lock size={12} />
            <p>Secured by R0eight</p>
          </div>
        </Card>
      )}
      {isOrder && tradeType === "Sell" && (
        <Card className="w-full bg-white rounded-2xl shadow-xl p-12 flex flex-col items-center text-center">
          <img
            src={purchase}
            alt="Sell Success"
            width={194}
            height={136}
            className="mb-6"
          />

          <h2 className="text-2xl font-bold text-purple-700 mb-4">
            Cash in Hand.
          </h2>
          <p className="text-lg font-normal text-gray-600 mb-6">
            You've freed up funds and kept control of your next move.
          </p>

          <Button
            onClick={onDone}
            className="w-full max-w-md py-3 bg-gradient-to-r from-purple-500 to-rose-500 text-white rounded-full font-bold h-16 mb-6"
          >
            Done
          </Button>

          <div className="flex items-center justify-center gap-1 text-sm text-gray-500">
            <Lock size={12} />
            <p>Secured by R0eight</p>
          </div>
        </Card>
      )}
    </>
  );
};

export default ForexComplete;
